import React from 'react';
import { useTranslation } from 'react-i18next';
// Importar estilos de las burbujas
import '../styles/bubble.css';

const Bubble = ({ 
  title, 
  content, 
  translationKey,  // Clave de traducción
  date, 
  position = 'center', 
  color = 'blue',
  size = 'medium',
  className = ''
}) => {
  const { t, i18n } = useTranslation();
  // Generar clases personalizadas según las props
  const bubbleClasses = `bubble bubble-${size} bubble-${color} bubble-${position} ${className}`;
  
  // Implementación directa y simplificada de traducción
  let displayTitle = title;
  let displayContent = content;
  let displayDate = date;
  
  // Si hay clave de traducción, intentamos obtener la traducción
  if (translationKey) {
    const titleKey = `${translationKey}.title`;
    const contentKey = `${translationKey}.content`;
    const dateKey = `${translationKey}.date`;
    
    // Log para depuración (puedes quitar esto después)
    console.log(`Idioma actual: ${i18n.language}`);
    console.log(`Intentando traducir: ${titleKey}`);
    console.log(`Título traducido: ${t(titleKey)}`);
    
    displayTitle = t(titleKey);
    displayContent = t(contentKey);
    if (date) displayDate = t(dateKey);
  }
  
  return (
    <div className={bubbleClasses}>
      {displayTitle && <h2>{displayTitle}</h2>}
      {displayContent && <p>{displayContent}</p>}
      {displayDate && <div className="bubble-date">{displayDate}</div>}
    </div>
  );
};

export default Bubble;
